module.exports = __webpack_public_path__ + "static/media/teaser1-droetker-x1.d0468396.jpg";